module.exports = __webpack_public_path__ + "static/media/lost-cherry.0cd12ca0.png";